export default __webpack_public_path__ + "static/media/alex-shipilov.cbed9aef.jpg";